import { useCustomTheme } from '@/core/theme'
import CircleIndicator from '@components/circle-indicator'
import { clsx } from 'clsx'
import { ReactElement } from 'react'
import {
    ButtonContent,
    LoadingIcon,
    StyledCustomButton,
} from './ActionButton.styles'
import Typography from '@/ui/components/typography'

interface Props {
    text?: string
    disabled?: boolean
    onClick?: (e?: any) => void
    className?: string
    loading?: boolean
    icon?: ReactElement
    dataTestId?: string
    children?: ReactElement
    buttonSize?: 'small' | 'regular'
    fontWeight?: 'regular' | 'medium' | 'semibold'
}

const ActionButton = ({
    text,
    disabled,
    onClick,
    className,
    loading,
    icon,
    dataTestId,
    children,
    buttonSize = 'regular',
    fontWeight = 'semibold',
}: Props) => {
    const { colors } = useCustomTheme()

    return (
        <StyledCustomButton
            disabled={disabled}
            textColor={colors.greys['0']}
            backgroundColor={colors.primary['400']}
            hoverBackgroundColor={colors.primary['600']}
            disableTextColor={colors.greys['400']}
            disableBackgroundColor={colors.greys['300']}
            className={clsx([className])}
            onClick={onClick}
            buttonSize={buttonSize}
            fontWeight={fontWeight}
            testId={
                dataTestId ??
                `${text?.split(' ').join('-').toLowerCase()}-button`
            }
        >
            {loading && (
                <LoadingIcon>
                    <CircleIndicator size={15} width={2} loading={true} />
                </LoadingIcon>
            )}
            {children}
            <ButtonContent>
                {text} {icon}
            </ButtonContent>
        </StyledCustomButton>
    )
}

export default ActionButton
